import React, { useState, useEffect } from "react";
import { Route, useLocation, useRouteMatch } from "react-router-dom";
import DriversOverviewDialog from "./DriversOverviewDialog";
import DriversUploadDialog from "./DriversUploadDialog";
import DriversEditDialog from "./DriversEditDialog";
import { connect } from "react-redux";
import { setDrivers } from "../../../store/actions/project";
import API from "../../../utils/axios";

function DriversDialog({
  saveDisabled,
  setSaveDisabled,
  setDrivers,
  plan,
  ...props
}) {
  const [currentAction, setCurrentAction] = useState("overview");

  const [currentDriver, setCurrentDriver] = useState(null);

  const [loadingDrivers, setLoadingDrivers] = useState(false);

  const location = useLocation();

  const [editingOutsideId, setEditingOutside] = useState(null);

  useEffect(() => {
    if (location.state && location.state.action === "edit-driver") {
      setEditingOutside(location.state.driverId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSaveDisabled(true);
    // refresh drivers on open
    if (!loadingDrivers && props.open) {
      setLoadingDrivers(true);
      API.get("/v1/drivers")
        .then(res => {
          setDrivers(res.data);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          setLoadingDrivers(false);
        });
    }
    return () => {
      setCurrentAction("overview");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, setSaveDisabled]);

  useEffect(() => {
    setSaveDisabled(true);
  }, [currentAction, setSaveDisabled]);

  const match = useRouteMatch("/drivers/upload");

  return (
    <>
      {!match &&
        (["edit", "add"].includes(currentAction) ? (
          <DriversEditDialog
            {...props}
            open={props.open}
            setCurrentAction={setCurrentAction}
            currentDriver={currentDriver}
            saveDisabled={saveDisabled}
            editingOutsideId={editingOutsideId}
            setSaveDisabled={setSaveDisabled}
          />
        ) : (
          <DriversOverviewDialog
            {...props}
            open={props.open && currentAction === "overview"}
            setCurrentAction={setCurrentAction}
            setCurrentDriver={setCurrentDriver}
            editingOutsideId={editingOutsideId}
          />
        ))}
      {plan.ft_spreadsheet_upload && (
        <Route path="/drivers/upload" exact>
          <DriversUploadDialog {...props} setCurrentAction={setCurrentAction} />
        </Route>
      )}
    </>
  );
}

const mapStateToProps = state => ({
  plan:
    (state.auth.userData.organisationSite &&
      state.auth.userData.organisationSite.organisation.plan) ||
    {},
});

export default connect(mapStateToProps, { setDrivers })(
  DriversDialog
);
